import { StrictMode } from 'react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './src/store/store';
import Example from './App.carbonspacedashboard';
import AppWrapper from './AppWrapper';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './src/components/common/ErrorFallback';
import { configureAmplify } from './src/config/amplify';
import { init as initAmplitude } from './src/services/amplitude';
import './index.css';

// Configure Amplify
configureAmplify();

// Initialize Amplitude
initAmplitude();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppWrapper>
            <Example />
          </AppWrapper>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </StrictMode>
);
